import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select';

import { fetchCostCenters } from '../store/actions/cost_centers/costCenterActions';

class CostCenterField extends Component {

  componentDidMount() {
    this.props.fetchCostCenters();
  }

  
  render() {
    let costCenters = this.props.costCenters.costCenters;
    let costCenter = this.props.costCenter;

    let defaultValueIndex = null;
    let costCenterOptions = [];

    if (!!costCenters && costCenters.length) {
      costCenterOptions = +costCenters.length && costCenters.map(costCenter => {
        return {
          label: costCenter.cost_center_code + " - " + costCenter.cost_center_name, 
          value: costCenter.id
        }
      })
    }

    if (costCenter) {
      if (typeof(costCenterOptions) === 'object')  {
        costCenterOptions.forEach((costCenterOpt, index) => {
          if (costCenterOpt.value === costCenter) {
            defaultValueIndex = index;
          }
        })
      }
    }

    return (
      <Select 
        value={costCenterOptions[defaultValueIndex]} 
        isSearchable={true}
        name="cost_center"  
        isMulti={false} 
        options={costCenterOptions} 
        onChange={(value) => this.props.onChangeCallback(value)}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  costCenters: state.costCenters 
})

const mapDispatchToProps = (dispatch) => ({
  fetchCostCenters: () => dispatch(fetchCostCenters())
})

export default connect(mapStateToProps, mapDispatchToProps)(CostCenterField)